import { Directive, Input, OnInit, ElementRef } from '@angular/core';
import { ScrollableItemsHelperOsService } from '../services/scrollable-items-helper-os.service';
import { ArraySectionDirectiveModel } from '../models/extended-section-options';

@Directive({
	selector: '[cvJsfArraySection]'
})
export class ArraySectionDirective implements OnInit {
	@Input() data: ArraySectionDirectiveModel;

	constructor(
		private scrollableHelper: ScrollableItemsHelperOsService,
		private elementRef: ElementRef
	) {}

	/**
	 * Check the directive data to confirm that the section attr its filled.
	 * If its filled and the skipDirective its false, proceed to add the item to the array.
	 */
	ngOnInit(): void {
		if (this.data.section && !this.data.skipDirective) {
			this.scrollableHelper.addItem(
				this.data.section,
				{
					id: this.data.cssClass,
					element: this.elementRef,
					visible: this.data.visible,
					rendered: false,
					section: this.data.section,
					metadata: this.data.metadata
				}
			);
		}
	}
}
